import { render, staticRenderFns } from "./OrderSale.vue?vue&type=template&id=6890d5c2&scoped=true"
import script from "./OrderSale.vue?vue&type=script&lang=js"
export * from "./OrderSale.vue?vue&type=script&lang=js"
import style0 from "./OrderSale.vue?vue&type=style&index=0&id=6890d5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890d5c2",
  null
  
)

export default component.exports